import script from "./DownloadFaqView.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadFaqView.vue?vue&type=script&setup=true&lang=js"

import "./DownloadFaqView.vue?vue&type=style&index=0&id=74539c77&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74539c77"]])

export default __exports__